import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useTheme,
  useMediaQuery,
  IconButton,
  Stack,
} from "@mui/material";
import React, { useState } from "react";
import { IoMdAdd } from "react-icons/io";
import useAlert from "../../../../hooks/useAlert";
import xmlDealerService from "../../../../services/xmlDealerService";
import AddUserDialog from "./AddUserDialog";
import UpdateUserDialog from "./UpdateUserDialog";

export const XmlDealer = () => {
  const [user, setUser] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [open, setOpen] = useState(false);
  const [openUpdate, setOpenUpdate] = useState(false);
  const [loading, setLoading] = useState(false);
  const { showErrorAlertAll, showSuccessAlertAll } = useAlert();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));
  const handleOpen = () => {
    setOpen(true);
  };
  const [xmlDealerShipId, setXmlDealerShipId] = useState(null);
  const handleClose = () => {
    setOpen(false);
  };
  const handleCloseUpdateModal = () => {
    setOpenUpdate(false);
  };
  const deleteUser = async (id) => {
    try {
      await xmlDealerService.deleteUsers(id);

      showSuccessAlertAll();
    } catch {
      showErrorAlertAll();
    }
  };
  const updateUser = (user) => {
    try {
      setSelectedUser(user);
      setOpenUpdate(true);
    } catch {
      showErrorAlertAll();
    }
  };
  const getXmlUser = async () => {
    if (xmlDealerShipId > 0) {
      var response = await xmlDealerService.fetchUsers(xmlDealerShipId);
      setUser(response?.data);
    }
  };
  return (
    <Box
      sx={{
        width: "100%",
        padding: { xs: 1, sm: 2, md: 4 },
        backgroundColor: "#f5f5f5",
        minHeight: "100vh",
      }}
    >
      <Box
        sx={{
          padding: { xs: 1, sm: 2 },
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          alignItems: { xs: "flex-start", sm: "center" },
          justifyContent: "space-between",
          gap: { xs: 2, sm: 0 },
          mb: 3,
          backgroundColor: "#fff",
          borderRadius: 2,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Box
            sx={{ width: 4, height: 24, backgroundColor: "#b71c1c", mr: 1 }}
          />
          <Typography
            variant="h6"
            color="black"
            sx={{
              textTransform: "uppercase",
              letterSpacing: "0.08em",
              fontSize: { xs: "1rem", sm: "1.25rem" },
            }}
          >
            XML Kullanıcı Ekle
          </Typography>
        </Box>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          width={{ xs: "100%", sm: "auto" }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={handleOpen}
            fullWidth={isMobile}
            sx={{
              borderRadius: 2,
              backgroundColor: "#1F1B45",
              color: "#FFFFFF",
              textTransform: "none",
              fontWeight: 500,
              fontSize: { xs: "0.75rem", sm: "0.875rem" },
              padding: { xs: "8px 16px", sm: "10px 20px" },
              display: "flex",
              alignItems: "center",
              gap: 1,
              height: "100%",
              boxShadow: "0 4px 8px rgba(31, 27, 69, 0.3)",
              "&:hover": {
                backgroundColor: "#2C285A",
                boxShadow: "0 6px 12px rgba(31, 27, 69, 0.4)",
              },
            }}
          >
            <IoMdAdd />
            Kullanıcı Ekle
          </Button>
        </Box>
      </Box>

      <Box
        elevation={3}
        sx={{
          p: { xs: 1, sm: 2 },
          mt: 2,
          backgroundColor: "white",
          overflowX: "auto",
        }}
      >
        {user?.length === 0 ? (
          <Typography align="center" sx={{ mt: 2 }}>
            Henüz kayıtlı kullanıcı yok.
          </Typography>
        ) : (
          <TableContainer
            sx={{
              maxHeight: { xs: "60vh", sm: "70vh" },
              minWidth: { xs: "100%", sm: "auto" },
            }}
          >
            <Table stickyHeader size={isMobile ? "small" : "medium"}>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ whiteSpace: "nowrap" }}>
                    <strong>İsim</strong>
                  </TableCell>
                  <TableCell sx={{ whiteSpace: "nowrap" }}>
                    <strong>Soyisim</strong>
                  </TableCell>
                  <TableCell sx={{ whiteSpace: "nowrap" }}>
                    <strong>TC</strong>
                  </TableCell>
                  <TableCell sx={{ whiteSpace: "nowrap" }}>
                    <strong>Telefon</strong>
                  </TableCell>
                  <TableCell sx={{ whiteSpace: "nowrap" }}>
                    <strong>Kullanıcı Adı</strong>
                  </TableCell>
                  <TableCell sx={{ whiteSpace: "nowrap" }}>
                    <strong>Şifre</strong>
                  </TableCell>
                  <TableCell sx={{ whiteSpace: "nowrap" }}>
                    <strong>İşlemler</strong>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {user?.map((user, index) => (
                  <TableRow key={index} hover>
                    <TableCell sx={{ whiteSpace: "nowrap" }}>
                      {user.name}
                    </TableCell>
                    <TableCell sx={{ whiteSpace: "nowrap" }}>
                      {user.surName}
                    </TableCell>
                    <TableCell sx={{ whiteSpace: "nowrap" }}>
                      {user.identifier}
                    </TableCell>
                    <TableCell sx={{ whiteSpace: "nowrap" }}>
                      {user.phone}
                    </TableCell>
                    <TableCell sx={{ whiteSpace: "nowrap" }}>
                      {user.userName}
                    </TableCell>
                    <TableCell sx={{ whiteSpace: "nowrap" }}>
                      {user.password}
                    </TableCell>
                    <TableCell>
                      <Stack
                        direction={{ xs: "column", sm: "row" }}
                        spacing={1}
                        sx={{ minWidth: { xs: "120px", sm: "auto" } }}
                      >
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={() => updateUser(user)}
                          fullWidth={isMobile}
                          sx={{
                            borderRadius: 2,
                            border: "1px solid #1F1B45",
                            color: "#1F1B45",
                            textTransform: "none",
                            fontWeight: 500,
                            fontSize: { xs: "0.75rem", sm: "0.813rem" },
                            padding: { xs: "4px 8px", sm: "6px 12px" },
                            display: "flex",
                            alignItems: "center",
                            gap: 0.5,
                            "&:hover": {
                              backgroundColor: "#F3F3F3",
                              border: "1px solid #2C285A",
                              color: "#2C285A",
                            },
                          }}
                          startIcon={
                            <EditIcon
                              sx={{ fontSize: { xs: "1rem", sm: "1.1rem" } }}
                            />
                          }
                        >
                          {isMobile ? "" : "Düzenle"}
                        </Button>

                        <Button
                          onClick={() => deleteUser(user.id)}
                          variant="outlined"
                          size="small"
                          fullWidth={isMobile}
                          sx={{
                            borderRadius: 2,
                            border: "1px solid #1F1B45",
                            color: "#1F1B45",
                            textTransform: "none",
                            fontWeight: 500,
                            fontSize: { xs: "0.75rem", sm: "0.813rem" },
                            padding: { xs: "4px 8px", sm: "6px 12px" },
                            display: "flex",
                            alignItems: "center",
                            gap: 0.5,
                            "&:hover": {
                              backgroundColor: "#F3F3F3",
                              border: "1px solid #2C285A",
                              color: "#2C285A",
                            },
                          }}
                          startIcon={
                            <DeleteIcon
                              sx={{ fontSize: { xs: "1rem", sm: "1.1rem" } }}
                            />
                          }
                        >
                          {isMobile ? "" : "Sil"}
                        </Button>
                      </Stack>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Box>

      {/* Kullanıcı Ekleme Dialog'unu çağırıyoruz */}
      <AddUserDialog
        open={open}
        onClose={handleClose}
        getXmlUser={getXmlUser}
        xmlDealerShipId={xmlDealerShipId}
        setXmlDealerShipId={setXmlDealerShipId}
      />

      <UpdateUserDialog
        open={openUpdate}
        onClose={handleCloseUpdateModal}
        getXmlUser={getXmlUser}
        selectedUser={selectedUser}
      />
    </Box>
  );
};

export default XmlDealer;
